import React from 'react';

/**
 * Loading skeleton shown whilst treatment selector is loading.
 */
const LoadingSkeleton = () => (
    <div>
        <div className="grid grid-cols-2 gap-100 mt-[1.875rem] md:grid-cols-3">
            <div className="skeleton-animation h-[6.75rem]" />
            <div className="skeleton-animation h-[6.75rem]" />
            <div className="skeleton-animation h-[6.75rem] hidden md:block" />
        </div>
        <div className="skeleton-animation mt-[2.5rem] h-[4.25rem]" />
        <div className="mt-150 space-y-075">
            <div className="skeleton-animation h-[2.5rem]" />
            <div className="skeleton-animation h-[2.5rem]" />
            <div className="skeleton-animation h-[2.5rem]" />
        </div>
        <div
            className="button button-primary button-size-large button-disabled mt-150 text-center"
            aria-hidden="true"
        >
            Get Started
        </div>
        <div className="skeleton-animation max-w-[23.75rem] mx-auto h-[1.25rem] mt-050" />
    </div>
);

export default LoadingSkeleton;
